import './style.less';
import virtualPath from 'meta/utils/virtualPath';

function debounce(func, timeout) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

function mergeArrayDictionaries(target, source) {
    for (const key in source) {
        const element = source[key];
        if (!target[key]) {
            target[key] = [];
        }
        target[key] = target[key].concat(element);
    }
}

function initializeFullSearchWindow() {
    // Generate HTML elements
    var searchContainer = document.createElement('div');
    searchContainer.classList.add('fullSearchContainer');
    searchContainer.addEventListener('click', function (e) { if (e.target === this) { window.RootExtensions.FullSearchWindow.close(); }});

    var searchBar = document.createElement('input');
    searchBar.type = 'text';
    searchBar.placeholder = 'Search…';
    searchBar.addEventListener('input', function (e) {
        window.RootExtensions.FullSearchWindow.runSearch(e.target.value);
    });
    searchContainer.appendChild(searchBar);

    var searchTitle = document.createElement('div');
    searchTitle.classList.add('fullSearchTitle');
    searchContainer.appendChild(searchTitle);

    var searchResults = document.createElement('div');
    searchResults.classList.add('fullSearchResults');
    searchContainer.appendChild(searchResults);

    var loader = document.createElement('div');
    loader.classList.add('fullSearchLoader');
    loader.classList.add('hidden');
    searchContainer.appendChild(loader);

    document.body.appendChild(searchContainer);

    var menuSearchField = document.createElement('div');
    menuSearchField.classList.add('fullSearchStartField');
    menuSearchField.innerHTML = '<span><i class="fa fa-search"></i>Search…</span>';
    menuSearchField.addEventListener('click', function() { window.RootExtensions.FullSearchWindow.open(); });

    let searchDataVersion = 0;

    // Register FullSearchWindow object
    if (!window.RootExtensions) window.RootExtensions = {};

    window.RootExtensions.FullSearchWindow = {
        moveResultFocus: function(step) {
            if (window.RootExtensions.FullSearchWindow.isActive()) {
                var focusedRow = searchResults.querySelector(".fullSearchResultsRow.focused");
                var rowToFocus = searchResults.firstChild;

                if (focusedRow) {
                    focusedRow.classList.remove('focused');

                    if (step > 0) {
                        rowToFocus = focusedRow.nextElementSibling;
                    } else {
                        rowToFocus = focusedRow.previousElementSibling;
                    }

                    if (!rowToFocus) {
                        rowToFocus = focusedRow;
                    }
                }

                rowToFocus.classList.add('focused');
                rowToFocus.scrollIntoViewIfNeeded(false);
            }
        },
        moveResultFocusTop: function() {
            if (window.RootExtensions.FullSearchWindow.isActive()) {
                var focusedRow = searchResults.querySelector(".fullSearchResultsRow.focused");
                if (focusedRow) {
                    focusedRow.classList.remove('focused');
                }

                var rowToFocus = searchResults.firstChild;
                if (rowToFocus) {
                    rowToFocus.classList.add('focused');
                    rowToFocus.scrollIntoViewIfNeeded(false);
                }
            }
        },
        moveResultFocusBottom: function() {
            if (window.RootExtensions.FullSearchWindow.isActive()) {
                var focusedRow = searchResults.querySelector(".fullSearchResultsRow.focused");
                if (focusedRow) {
                    focusedRow.classList.remove('focused');
                }

                var rowToFocus = searchResults.lastChild;
                if (rowToFocus) {
                    rowToFocus.classList.add('focused');
                    rowToFocus.scrollIntoViewIfNeeded(false);
                }
            }
        },
        selectFocusedRow: function(e) {
            if (window.RootExtensions.FullSearchWindow.isActive()) {
                var focusedRow = searchResults.querySelector(".fullSearchResultsRow.focused");
    
                if (focusedRow && focusedRow.firstChild) {
                    focusedRow.firstChild.click();
                    e.stopPropagation();
                    e.preventDefault();
                }
            }
        },
        toggle: function () {
            if (window.RootExtensions.FullSearchWindow.isActive()) {
                window.RootExtensions.FullSearchWindow.close();
            } else {
                window.RootExtensions.FullSearchWindow.open();
            }
        },
        isActive: function () {
            return searchContainer.classList.contains("active");
        },
        open: function () {
            if (window.RootState && window.RootState.loggedUsername) {
                searchContainer.classList.add("active");
                searchBar.focus();
                window.RootExtensions.FullSearchWindow.runSearch(searchBar.value);
            }
        },
        close: function () {
            searchContainer.classList.remove("active");

            window.RootExtensions.FullSearchWindow.reset();
        },
        runSearch: function (value) {
            window.RootExtensions.FullSearchWindow.resetResults();
            searchDataVersion++;
            var enabledSearchEngines = ['topMenu', 'prescriptions']

            if (value) {
                searchTitle.innerText = "";
                loader.classList.remove('hidden');

                let appendResultsWithVersion = (items) => window.RootExtensions.FullSearchWindow.appendResults(items, searchDataVersion);
                let disableLoadingWithVersion = () => window.RootExtensions.FullSearchWindow.disableLoading(searchDataVersion);
                let promises = []
                for (var i = 0; i < enabledSearchEngines.length; i++) {
                    let searchPromise = window.RootExtensions.FullSearchWindow.searchModules[enabledSearchEngines[i]].engine(value);
                    searchPromise.then(appendResultsWithVersion);
                    promises.push(searchPromise);
                }
                Promise.all(promises).then(disableLoadingWithVersion);
            } else if (window.RootState.loggedUsername) {
                if (window.localStorage.fullSearchWindowSearchHistory) {
                    var searchHistory = JSON.parse(window.localStorage.fullSearchWindowSearchHistory);
    
                    if (window.RootState.loggedUsername in searchHistory)
                    {
                        searchTitle.innerText = "Recent";
                        var recentSearches = searchHistory[window.RootState.loggedUsername];

                        for (var i = 0; i < recentSearches.length; i++) {
                            var recentSearchElement;
                            if (recentSearches[i].type in window.RootExtensions.FullSearchWindow.searchModules &&
                                window.RootExtensions.FullSearchWindow.searchModules[recentSearches[i].type].recentElementGenerator) {
                                recentSearchElement =
                                    window.RootExtensions.FullSearchWindow.searchModules[recentSearches[i].type].recentElementGenerator(recentSearches[i]);

                            } else {
                                recentSearchElement = window.RootExtensions.FullSearchWindow.generateResultRow(recentSearches[i].title, recentSearches[i].note);
                                recentSearchElement.addEventListener('click', function () {
                                    searchBar.value = this.getAttribute('data-title');
                                    window.RootExtensions.FullSearchWindow.runSearch(this.getAttribute('data-title'));
                                });
                            }

                            window.RootExtensions.FullSearchWindow.appendResults([recentSearchElement], searchDataVersion);
                        }

                    }
                }
            }
        },
        reset: function () {
            searchBar.value = '';
            window.RootExtensions.FullSearchWindow.runSearch();
        },
        resetResults: function () {
            while (searchResults.firstChild) {
                searchResults.removeChild(searchResults.firstChild);
            }

            window.RootExtensions.FullSearchWindow.focusedIndex = -1;
        },
        appendResults: function (results, version) {
            if (version !== searchDataVersion) {
                return;
            }

            for (var i = 0; i < results.length; i++) {
                var resultRow = document.createElement('div');
                resultRow.classList.add('fullSearchResultsRow');

                if (results[i] instanceof Element) {
                    resultRow.appendChild(results[i]);
                } else {
                    resultRow.innerHTML = results[i];
                }

                searchResults.appendChild(resultRow);
            }

            if (!searchResults.querySelector(".fullSearchResultsRow.focused")) {
                var rowToFocus = searchResults.firstChild;

                if (rowToFocus) {
                    rowToFocus.classList.add('focused');
                }
            }
        },
        disableLoading: function (version) {
            if (version !== searchDataVersion) {
                return;
            }

            loader.classList.add('hidden');
        },
        generateResultRow: function (title, note, icon) {
            var resultRowElement = document.createElement('div');
            resultRowElement.innerHTML = '<i class="fa ' + (icon || 'fa-search') + '"></i><span>' + title + '</span>' + (note ? ('<span class="secondary-text">' + note + '</span>') : '');
            resultRowElement.setAttribute('data-title', title);

            return resultRowElement;
        },
        updateRecentSearches: function (value) {
            var recentSearches = [];

            if (!window.localStorage.fullSearchWindowSearchHistory) {
                window.localStorage.fullSearchWindowSearchHistory = JSON.stringify({});
            }

            if (window.RootState.loggedUsername) {
                var searchHistory = JSON.parse(window.localStorage.fullSearchWindowSearchHistory);

                if (window.RootState.loggedUsername in searchHistory) {
                    recentSearches = searchHistory[window.RootState.loggedUsername];
                } else {
                    recentSearches = [];
                }

                recentSearches = recentSearches.filter(function(x) { return x.title !== value.title || x.note !== value.note}).slice(0, 4);
                recentSearches.unshift(value);

                searchHistory[window.RootState.loggedUsername] = recentSearches;

                window.localStorage.fullSearchWindowSearchHistory = JSON.stringify(searchHistory);
            }
        },
        searchModules: {
            topMenu: {
                engine: function (value) {
                    return new Promise(function (resolve, reject) {
                        var menus = [];
                        var valueUpperCase = value.toUpperCase();
                        var resultsBuilder = function(items, value, path) {
                            let matchesByPriorities = {}
                            for (var i = 0; i < items.length; i++) {
                                var id = items[i].ID;
                                var title = items[i].Title;
                                var url = items[i].Url;

                                let matchPriority = -1;
                                if (url) {
                                    // exact match
                                    if (title.toUpperCase() === valueUpperCase || id.toUpperCase() === valueUpperCase) {
                                        matchPriority = 3;
                                    }
                                    // starts with
                                    else if (title.toUpperCase().startsWith(valueUpperCase)) {
                                        matchPriority = 2;
                                    }
                                    // includes
                                    else if (title.toUpperCase().includes(valueUpperCase)) {
                                        matchPriority = 1;
                                    }
                                }
                                
                                if (matchPriority !== -1) {
                                    var resultElement = window.RootExtensions.FullSearchWindow.generateResultRow(items[i].Title, path, 'fa-bars');
    
                                    resultElement.setAttribute('data-id', items[i].ID);
                                    resultElement.setAttribute('data-note', path);
                                    resultElement.addEventListener(
                                        "click", window.RootExtensions.FullSearchWindow.searchModules.topMenu.clickHandler, true);

                                    if (!matchesByPriorities[matchPriority]) {
                                        matchesByPriorities[matchPriority] = [];
                                    }

                                    matchesByPriorities[matchPriority].push(resultElement);
                                }
    
                                if (items[i].SubMenuItems) {
                                    var subMenuMatches = resultsBuilder(items[i].SubMenuItems, value, path + "/" + items[i].Title);
                                    mergeArrayDictionaries(matchesByPriorities, subMenuMatches);
                                }
                            }
    
                            return matchesByPriorities;
                        }
    
                        try {
                            menus = window.RootState.topMenus;
                        }
                        catch (error) {
                            console.error(error);
                            reject('<span style="color: red">Top menu search engine failed</span>');
                        }
    
                        var prioritisedResults = {}
                        for (var i = 0; i < menus.length; i++) {
                            var matchesByPriorities = resultsBuilder(menus[i].Items, valueUpperCase, "/" + menus[i].Title)
                            mergeArrayDictionaries(prioritisedResults, matchesByPriorities)
                        }

                        var flattenedResults = [];
                        var keys = Object.keys(prioritisedResults).sort().reverse(); // highest priorities first
                        for (const key of keys) {
                            flattenedResults = flattenedResults.concat(prioritisedResults[key]);
                        }
    
                        resolve(flattenedResults);
                    });
                },
                recentElementGenerator: function(data) {
                    var recentSearchElement = window.RootExtensions.FullSearchWindow.generateResultRow(data.title, data.note, 'fa-bars');
                    recentSearchElement.setAttribute('data-id', data.top_menu_id);
                    recentSearchElement.setAttribute('data-note', data.note);
                    recentSearchElement.addEventListener(
                        "click", window.RootExtensions.FullSearchWindow.searchModules.topMenu.clickHandler, true);

                    return recentSearchElement;
                },
                clickHandler: function(e) {
                    var clickedId = this.getAttribute('data-id');
                    var recordFinder = function (items, ID) {
                        for(var i = 0; i < items.length; i++) {
                            if (items[i].ID === ID) {
                                return items[i];
                            }

                            if (items[i].SubMenuItems) {
                                var item = recordFinder(items[i].SubMenuItems, ID);
                                if (item) {
                                    return item;
                                }
                            }
                        }

                        return null;
                    }
                    
                    var topMenus = window.RootState.topMenus;
                    var item = null;
                    for (var i = 0; i < topMenus.length; i++) {
                        item = recordFinder(topMenus[i].Items, clickedId);

                        if (item) {
                            break;
                        }
                    }

                    if (item) {
                        window.RootExtensions.FullSearchWindow.updateRecentSearches(
                            {
                                title: item.Title,
                                type: "topMenu",
                                note: this.getAttribute('data-note'),
                                top_menu_id: item.ID
                            });
                        window.RootExtensions.FullSearchWindow.close();

                        window.RootAPI.Navigation.openContentUrl(item.Url.substr(3), item.Title);
                    }
                }
            },
            prescriptions: {
                engine: function (value) {
                    return new Promise(function (resolve, reject) {
                        if (value.substring(0, 2) == 'p/') {
                            window.RootExtensions.FullSearchWindow.searchModules.prescriptions.fetchDebounced(value, resolve, reject);
                        }
                        else {
                            resolve([]);
                        }
                    });
                },
                fetchDebounced: debounce((value, resolve, reject) => {
                    let prescriptionNo = value.substring(2);
                    let xhr = new XMLHttpRequest();
                    xhr.open('GET', virtualPath + '/webapi/root/prescriptions?value=' + prescriptionNo);
                    xhr.responseType = 'json';
                    xhr.onload = function () {
                        let response = xhr.response;
                        let results = []
                        if (response) {
                            let resultElement = window.RootExtensions.FullSearchWindow.generateResultRow(response.name, response.visName, 'fa-file-text');
                            resultElement.setAttribute('data-ordid', response.ordId);
                            resultElement.setAttribute('data-prescriptionno', prescriptionNo);
                            resultElement.setAttribute('data-visname', response.visName);
                            resultElement.setAttribute('data-medname', response.name);
                            resultElement.setAttribute('data-visid', response.visId);
                            resultElement.addEventListener(
                                "click", window.RootExtensions.FullSearchWindow.searchModules.prescriptions.clickHandler, true);
                            results.push(resultElement)
                        }

                        resolve(results);
                    }
                    xhr.onerror = function () {
                        reject('<span style="color: red">Prescriptions search failed</span>')
                    }
                    xhr.send();
                }, 200),
                recentElementGenerator: function (data) {
                    var recentSearchElement = window.RootExtensions.FullSearchWindow.generateResultRow(data.medName + ' (' + data.prescriptionNo + ')', data.visName, 'fa-file-text');
                    recentSearchElement.setAttribute('data-ordid', data.ordId);
                    recentSearchElement.setAttribute('data-prescriptionno', data.prescriptionNo);
                    recentSearchElement.setAttribute('data-visname', data.visName);
                    recentSearchElement.setAttribute('data-medname', data.medName);
                    recentSearchElement.setAttribute('data-visid', data.visId);
                    recentSearchElement.addEventListener(
                        "click",
                        function(e) {
                            let xhr = new XMLHttpRequest();
                            xhr.open('GET', virtualPath + '/webapi/root/prescriptions?value=' + data.prescriptionNo);
                            xhr.onload = function () {
                                if (xhr.response) {
                                    window.RootExtensions.FullSearchWindow.searchModules.prescriptions.clickHandler.apply(recentSearchElement, e)
                                }
                            }
                            xhr.send();
                        },
                        true);

                    return recentSearchElement;
                },
                clickHandler: function (e) {
                    var ordId = this.getAttribute('data-ordid');
                    var medName = this.getAttribute('data-medname');
                    var visName = this.getAttribute('data-visname');
                    var visId = this.getAttribute('data-visid');
                    var prescriptionNo = this.getAttribute('data-prescriptionno');

                    window.RootExtensions.FullSearchWindow.updateRecentSearches(
                        {
                            medName,
                            visName,
                            prescriptionNo,
                            visId,
                            type: "prescriptions",
                            ordId
                        });
                    window.RootExtensions.FullSearchWindow.close();
                    window.RootAPI.Navigation.openPatientDetailByUrl(
                        virtualPath + '/CPOE/AdjudicationClaims.aspx'
                        + '?visID=' + visId
                        + '&detailID=' + ordId
                        + '&menuId=a4cffcbc-8594-4090-8519-ea0332d890c3'
                        + '&usePrescriptionVersion=true'
                        + '&f=AdjudicationClaims'
                        + '&x=adjudication'
                    );
                }
            }
        }
    };

    let headlessKey = "headlesstokenauthorization";
    let query = window.location.search
    if (!query.includes(headlessKey)) {
        // Register shortcut for opening
        window.Hotkeys.bind({ 'ctrl+m': window.RootExtensions.FullSearchWindow.toggle }, true, true);
    }
    window.Hotkeys.bindHere({
        'up': function (e) { if (window.RootExtensions.FullSearchWindow.isActive()) { e.preventDefault(); window.RootExtensions.FullSearchWindow.moveResultFocus(-1); } },
        'down': function (e) { if (window.RootExtensions.FullSearchWindow.isActive()) { e.preventDefault(); window.RootExtensions.FullSearchWindow.moveResultFocus(1); } },
        'enter': window.RootExtensions.FullSearchWindow.selectFocusedRow,
        'esc' : window.RootExtensions.FullSearchWindow.close,
        'home': function(e) { e.preventDefault(); window.RootExtensions.FullSearchWindow.moveResultFocusTop(); },
        'end': function(e) { e.preventDefault(); window.RootExtensions.FullSearchWindow.moveResultFocusBottom(); }
    }, true);
}

export default initializeFullSearchWindow
